import getComponentTokens from './index';
import TransformerWeb from '../../transformations/web';
import config from '@nn-design-system/config/web';
export default function getTransformedComponentTokens() {
    return getComponentTokens(new TransformerWeb(), config);
}
